export default __webpack_public_path__ + "static/media/cus1.e501fdd7.png";